import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { TerritoryRequest } from '../../../domain/TerritoryRequest';
import { useTranslation } from 'react-i18next';

interface Props {
    requests: TerritoryRequest[];
    onRequestDelete: (request: TerritoryRequest) => void;
}

export default (props: Props) => {
    const { t } = useTranslation();

    if (props.requests.length > 0) {
        return (
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        {props.requests.map((request, i) => (
                            <TableRow key={i}>
                                <TableCell padding='none' >{i + 1}</TableCell>
                                <TableCell>
                                    {`${request.territory!.title}`}
                                </TableCell>
                                <TableCell padding='none'>
                                    <IconButton size='small' onClick={() => props.onRequestDelete(request)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    } else {
        return <Typography>{t("no_territory_requests_yet")}</Typography>
    }


};